<template>
  <div :style="styles">
    <div class="jss_fullscreen_above" v-if="isFullScreen">
      <slot>
      </slot>
    </div>
    <div @contextmenu="onContext" style="width: 100%;">
      <div style="text-align: start; display: flex;">
        <div class="pl-2 error--text" v-if="computedErrorListCnt > 0 || computedOutsideErrorListCnt > 0">
          {{ computedErrMsgTitle }}
        </div>
      </div>
      <div ref="spreadsheetContainer">
        <div ref="spreadsheet" />
      </div>

      <!--
        -- カスタム項目を表示するように裏で都度位置を変更する
        -->
      <!-- 日付項目 -->
      <span class="inputDateArea" style="position: absolute; visibility: hidden; width: 0px;">
        <dd-date-box
          noLabel
          :readonly="disabled"
          v-model="inputDate"
          ref="inputDate"
          @input="onInputDate"
        />
      </span>
      <!-- アイコンボタン項目 -->
      <span class="iconButtonArea" style="position: absolute; visibility: hidden; width: 0px;">
        <dd-icon-button
          noLabel
          :readonly="disabled"
          ref="iconButton"
        />
      </span>
      <link href="https://fonts.googleapis.com/css?family=Material+Icons|Material+Icons+Outlined|Material+Icons+Two+Tone|Material+Icons+Round|Material+Icons+Sharp" rel="stylesheet">

      <!-- 行追加用ダイアログ -->
      <v-dialog v-model="rowAppendDialog" width="340">
        <v-card>
          <v-card-text>
            <v-container class="ma-0 pa-0">
              <v-row no-gutters style="background-color:#2D71BF;">
                <v-col :cols="12" class="px-1">
                  <div class="sps-section-title" style="color:#FFF">レコード追加（複数行）</div>
                  <hr class="sps-section-line" />
                </v-col>
              </v-row>
              <v-row no-gutters class="pb-2">
                <v-col cols="4">
                  <v-row no-gutters justify="end" class="pr-2">
                    <span style="padding-top: 6px !important">追加する行数:</span>
                  </v-row>
                </v-col>
                <v-col cols="3" class="px-1">
                  <v-text-field v-model="appendRow" @blur="onBlurAppendRow()" class="right-input" type="number" hide-details outlined dense />
                </v-col>
              </v-row>
              <div class="mx-1" style="border: 1px solid #83BDE5;border-radius: 10px;">
                <span class="px-2"><b>入力補助</b></span>
                <hr style="border: 0.5px solid #83BDE5" />
                <v-row no-gutters class="px-1">
                  <dd-icon-button-with-tooltip color="green" icon="mdi-alpha-c-circle" @click="resetAppendRow" message="入力行数を初期化します。" />
                  <span class="ml-2" />
                  <span v-for="n in 9" :key="n">
                    <dd-icon-button color="primary" :icon="'mdi-numeric-' + n + '-circle-outline'" @click="overwriteAppendRow(n)" />
                  </span>
                  <dd-icon-button color="primary" icon="mdi-numeric-0-circle-outline" @click="overwriteAppendRow(0)" />
                </v-row>
              </div>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row no-gutters class="px-1">
              <dd-custom-button
                color="primary"
                :minWidth="100"
                @click="rowAppendDialog = false">
                キャンセル
              </dd-custom-button>
              <v-spacer />
              <dd-custom-button
                color="primary"
                :minWidth="100"
                :disabled="appendRow > 100"
                @click="rowAppendMulti">
                追加
              </dd-custom-button>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import 'jsuites/dist/jsuites.css'
import 'jspreadsheet/dist/jspreadsheet.css'
import 'jspreadsheet/dist/jspreadsheet.themes.css'
import jSpreadSheet from 'jspreadsheet'
import formula from '@jspreadsheet/formula-pro'

import controls from '@/rahmen/controls'
import complements from '@/rahmen/complement'
import filter from '@/rahmen/utils/filters'
import inputMixin from '@/mixins/inputMixins'
import message from '@/ddv2.library/messages'
// import spsvalidator from '@/ddv2.library/validator4sps'
import validators from '@/rahmen/validators'
// import core from '@/rahmen/core'
// import dolly from '@/rahmen/utils/dolly'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import DdCustomButton from '@/components/DdCustomButton'
import DdDateBox from '@/components/DdDateBox'
import DdIconButton from '@/components/DdIconButton'
import DdIconButtonWithTooltip from '@/components/DdIconButtonWithTooltip'

dayjs.extend(customParseFormat)

/**
 * @file datatec用スプレッドシート
 * @namespace components
 */

/**
 * @vue-prop {Boolean} [required=false] - 必須有無
 * @vue-prop {String} [errorMessages=''] - エラーメッセージ
 * @example
  <dt-time-box
    label=""
    v-model="timeValue"
    ref="timeValue"
    displayFormat="HH:mm">
 */
export default {
  name: 'DdSpreadSheet',
  mixins: [inputMixin],
  components: {
    DdDateBox,
    DdCustomButton,
    DdIconButton,
    DdIconButtonWithTooltip
  },
  props: {
    // オプション
    options: Object,
    // v-model
    value: {
      type: Array,
      default: () => []
    },
    // header
    column: Array,
    // headerのhedaer
    nestedHeaders: Array,
    // footer
    footer: Array,
    // 右クリック内容を書き換えたいなら指定
    contextMenu: Function,
    // 一部のみ追加したい場合はこちらを使用
    customContextMenuItem: Object,
    // カスタムツールバー
    customToolbarItem: Array,
    // カスタムツールバー(ヘッダー部一番左に配置)
    customToolbarItemPrepend: Array,
    // 編集不可
    disabled: {
      type: Boolean,
      default: false
    },
    // 編集フラグ管理するか
    isManageEditFlg: {
      type: Boolean,
      default: true
    },
    isUseToolbar: {
      type: Boolean,
      default: true
    },
    // ダウンロードボタンを使用するか
    isUseDownloadToolbar: {
      type: Boolean,
      default: true
    },
    // カラーボタンを使用するか
    isUseColorToolbar: {
      type: Boolean,
      default: false
    },
    // 再読み込みや保存ボタンを使うか
    isUseControlToolbar: {
      type: Boolean,
      default: true
    },
    // 保存ボタンを使うか
    isUseSaveToolbar: {
      type: Boolean,
      default: true
    },
    // 戻る/進むボタンを使うか
    isUseUndoRedo: {
      type: Boolean,
      default: true
    },
    // 右クリックの行追加を使用するか
    isUseAddRow: {
      type: Boolean,
      default: false
    },
    // 右クリックの行編集を使用するか
    isUseEditRow: {
      type: Boolean,
      default: false
    },
    // 右クリックの行削除を使用するか
    isUseDeleteRow: {
      type: Boolean,
      default: false
    },
    // 右クリックの行クリアを使用するか
    isUseClearRow: {
      type: Boolean,
      default: false
    },
    // 右クリックのセル結合を使用するか
    isUseMergeCell: {
      type: Boolean,
      default: false
    },
    // 右クリックの行追加を各行単位で表示するかしないかを判断 ※useDeleteRowがtrueの必要あり
    isUseAddRowForEachLine: {
      type: Function,
      default: null
    },
    // 右クリックの行削除を各行単位で表示するかしないかを判断 ※useDeleteRowがtrueの必要あり
    isUseDeleteRowForEachLine: {
      type: Function,
      default: null
    },
    // 右クリックの行クリアを各行単位で表示するかしないかを判断 ※useDeleteRowがtrueの必要あり
    isUseClearRowForEachLine: {
      type: Function,
      default: null
    },
    // jspreadsheetの項番列表示制御
    isDisplayIndex: {
      type: Boolean,
      default: true
    },
    // 読み取り状態
    isShoukaiMode: Boolean,
    // 外部から渡されるエラーリスト
    // { rowId: スプレッドシート行番号, x: -1(項番のこと), msg: エラーメッセージ }
    outsideErrorList: {
      type: Array,
      default: () => []
    },
    // 空白セル表示
    isUseMinDimensions: {
      type: Boolean,
      default: false
    },
    isDisabledChangeEmphasis: {
      type: Boolean,
      default: false
    },
    // 全画面用上部エリア高さ
    fullscreenAboveHeight: {
      type: Number,
      default: 42
    },
    // 検索条件表示HTML
    spreadDescription: {
      type: String,
      default: null
    },
    /*
     * 各セル読み取り状態制御メソッド
     * setReadonlyCell(rowData, columnName)
     * @param { rowData } 対象セルの行データ
     * @param { columnName } 対象セルに対応する項目名称
     * @return { boolean? } true: 読み取り専用セルに false:編集可能セルに null: 何もしない
     */
    setReadonlyCell: {
      type: Function,
      default: null
    },
    // ツールバー説明表示/非表示
    isShowIconDescription: {
      type: Boolean,
      default: true
    },
    // 各セルに対するエラーチェックを有効にする
    isEnableSetErrorCell: {
      type: Boolean,
      default: true
    },
    // 「上に挿入」を使用するか
    isUseAddRowAbove: {
      type: Boolean,
      default: true
    },
    // 「下に挿入」を使用するか
    isUseAddRowUnder: {
      type: Boolean,
      default: true
    },
    // スプレッド部分の画面サイズを自動計算するか
    isAutoSize: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    // dataSS: [],
    // ライセンス
    license: 'NWVmMjllOTk4NjA3NjIxNTQ2YmI0MTNkMzRhMzA3MDMzNzYxN2IyYWM4YWVlNTRiZmIwZDA2MzcwZTU0ZWIxYWUzMDkyM2FkNTA4ZDFmMjk4NjE3Y2Q1YjIwM2EyNGJiZTJhZDEwNzcyZDA3MWY0NTQxOGIzYjE5ZjMxNzEwZmMsZXlKdVlXMWxJam9pWEhVMFpXRmxJaXdpWkdGMFpTSTZORGcyTnpBNE5EZ3dNQ3dpWkc5dFlXbHVJanBiSW1SeWFYWmxMV1J2YjNJdVkyOXRJaXdpZDJWaUlpd2liRzlqWVd4b2IzTjBJbDBzSW5Cc1lXNGlPaUl5TWlJc0luTmpiM0JsSWpwYkluWTNJaXdpZGpnaUxDSjJPU0lzSW5ZeE1DSXNJbVp2Y20xMWJHRWlMQ0ptYjNKdGN5SXNJbkpsYm1SbGNpSXNJbkJoY25ObGNpSXNJbWx0Y0c5eWRHVnlJaXdpZG1Gc2FXUmhkR2x2Ym5NaUxDSmpiMjF0Wlc1MGN5SXNJbk5sWVhKamFDSXNJbU5vWVhKMGN5SmRmUT09',
    // スプレッドシートオプション
    defaultOption: {
      toolbar: true,
      // テーブル最大高さ
      tableHeight: '300px',
      // テーブル最大横幅
      tableWidth: 'inherit',
      // 列追加
      allowInsertColumn: false,
      // 行追加※改行キーのみ
      allowManualInsertRow: false,
      // 列削除
      allowDeleteColumn: false,
      // 行削除
      allowDeleteRow: false,
      // 列ドラッグ
      columnDrag: false,
      // 行ドラッグ
      rowDrag: false,
      // ソート
      columnSorting: false,
      // スクロール有効化
      tableOverflow: true,
      // コンテキストメニュー
      contextmenu: false,
      // セル内HTML無効※ヘッダー改行のため有効
      stripHTML: false,
      // 計算式のサポート
      parseFormulas: true,
      // 計算結果のキャッシュ※表データ変更時に予期せぬタイミングで計算式が動いてエラーになるため使用しない
      preCalculation: false,
      // セル選択時の右下の■ドラッグでのコピー
      selectionCopy: true,
      // CSV出力
      allowExport: false
      // フィルターオプション
      // search: true,
      // ページネーションオプション
      // ※ページネーションを有効にするとtableHeightが効かなくなるので注意
      // pagination: 50,
      // paginationOptions: [10, 25, 50, 100]
    },
    // validateエラーを格納
    errorList: [],
    // 日付項目
    inputDate: null,
    // 選択セル情報 例えばフォーカスを復元したい時に使用
    selectedCell: [],
    selectedX: null,
    selectedY: null,
    // 行追加用
    rowAppendDialog: false,
    appendRow: null,
    // フルスクリーン
    isFullScreen: false,
    // ここに現在の固定列数を保持
    freezeColumnsRuntime: 0
  }),
  created () {
  },
  mounted () {
    // // 一度スプレッドシート内部データにコピー
    // this.dataSS = dolly.clone(this.value)
    if (this.isAutoSize) {
      this.setSpreadsheetSize()
      window.addEventListener('resize', this.setSpreadsheetSize)
    }
    // 初期値の取り込み（親のoptionsにfreezeColumnsがあれば拾う）
    this.freezeColumnsRuntime = Number(this.options?.freezeColumns ?? 0)
    this.setSpreadSheet()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setSpreadsheetSize)
  },
  computed: {
    // バインドするスタイルを生成
    styles () {
      console.log('--fullscreen-top', (58 + this.fullscreenAboveHeight) + 'px')

      const heightAdjust = [undefined, null, 0].includes(this.fullscreenAboveHeight) ? 0 : (this.fullscreenAboveHeight) / 10

      return {
        '--fullscreen-top': (58 + this.fullscreenAboveHeight) + 'px',
        '--fullscreen-top-above-height': this.fullscreenAboveHeight + 'px',
        '--fullscreen-height': (94 - (heightAdjust)) + '%'
      }
    },
    computedDatas () {
      console.log('computedDatas', this.value)
      if (!Array.isArray(this.value)) return []
      // var rowId = 1
      return this.value.map(elem => {
        // // 行を特定するIDを付与
        // elem.rowIdForSS = rowId
        // rowId++
        return elem
      })
    },
    computedDatasNotDelete () {
      console.log('computedDatasNotDelete', this.computedDatas)
      return this.computedDatas.filter(elem => {
        return elem.deleteFlg !== true
      })
    },
    computedColumns () {
      return this.column.map((elem, index) => {
        // colIndex
        elem.colIndex = index
        // 共通カスタマイズ項目
        if (['customDate', 'date'].includes(elem.type) || ['customDate', 'date'].includes(elem.customInput)) {
          // 日付項目 日付ピッカー付き
          // 補完処理
          const dateComplement = (value) => { return complements.parseDate(value) }
          elem.complement = dateComplement
        } else if (elem.type === 'time' || elem.customInput === 'time') {
          const timeComplement = (value) => { return complements.parseTime(value) }
          elem.complement = timeComplement
        }

        // validate付与
        if (![undefined, null].includes(elem.validateType)) {
          elem.validInfo = {
            inputType: elem.validateType,
            length: elem.validateLength,
            intDigit: elem.validateIntDigit,
            decimalDigit: elem.validateDecimalDigit,
            max: elem.validateMax,
            min: elem.validateMin,
            isStraddle: elem.validateIsStraddle
          }
        }
        return elem
      })
    },
    computedErrMsgTitle () {
      return message ? message.get('COME0001') : ''
    },
    computedErrorList () {
      return this.errorList
    },
    computedErrorListCnt () {
      return this.computedErrorList.length
    },
    computedOutsideErrorListCnt () {
      return this.outsideErrorList.length
    }
  },
  watch: {
    value: function (n, o) {
      if (this.jspreadsheetObj) {
        console.log('watch value', this.value, n, o)
        // 選択セルを取得
        this.selectedCell = this.jspreadsheetObj.selectedCell
        // 描画し直し
        this.loadData()
        // filterが狂うことがあるため設定し直し
        const filter = this.jspreadsheetObj.getFilter()
        for (var key in filter) {
          if (filter[key]) {
            console.log('watch value key', key)
            this.jspreadsheetObj.setFilter(key, filter[key])
          }
        }
        if (this.selectedCell != null) {
          // 初期表示時や外部から表データを弄った時は選択セルがないから存在確認
          const left = this.selectedCell[0] || 0
          const top = this.selectedCell[1] || 0
          const right = this.selectedCell[2] || 0
          const bottom = this.selectedCell[3] || 0
          // 選択セルを選択し直す（表を作り直してるから選択解除になっている）
          this.jspreadsheetObj.updateSelectionFromCoords(left, top, right, bottom)
        }
      }
    },
    column: function (n, o) {
      console.log('watch column', n, o)
      this.$nextTick(() => {
        // DOMの更新を待つようにすると特に初期表示時の描画がスムーズに
        this.reSetSpreadSheet()
        this.setOutsideErrorList()
      })
    },
    outsideErrorList: function (n, o) {
      console.log('watch outsideErrorList', n, o)
      this.setOutsideErrorList(this.outsideErrorList)
    },
    isEnableDD: function (n, o) {
      // this.options.rowDrag = n
      const ws = this.jspreadsheetObj.getWorksheetActive()
      const wss = this.jspreadsheetObj.getWorksheetInstance(ws)
      const op = wss.getConfig()
      op.rowDrag = n
      wss.setConfig(op)
    }
  },
  methods: {
    setSpreadsheetSize () {
      this.$nextTick(() => {
        const windowHeight = window.innerHeight

        // Jspreadsheetのコンテンツ領域までのオフセット
        const spreadsheetTop = this.$refs.spreadsheetContainer.getBoundingClientRect().top

        // 下に残したい余白（フッターやボタンの高さ分）
        const bottomMargin = 220

        // 計算した最大高さ
        const maxHeight = windowHeight - spreadsheetTop - bottomMargin

        const contentOverflow = this.$refs.spreadsheetContainer.querySelector('.jss_content_overflow')
        if (contentOverflow) {
          contentOverflow.style.maxHeight = `${maxHeight}px`
          contentOverflow.style.overflowY = 'auto' // 念のため明示
        }
      })
    },
    setSpreadSheet: function () {
      console.log('setSpreadSheet')
      const self = this

      // オプションをクローンしてから編集
      const base = this.options
        ? JSON.parse(JSON.stringify(this.options))
        : JSON.parse(JSON.stringify(this.defaultOption))

      // ⭐ 常にランタイム値を優先して起動
      base.freezeColumns = Number(this.freezeColumnsRuntime || 0)

      // オプション
      var option = this.options ? this.options : this.defaultOption
      // ツールバー
      if (self.isUseToolbar) {
        var toolbarItems = []
        if (self.customToolbarItemPrepend) {
          toolbarItems.push(...self.customToolbarItemPrepend)
        }
        if (!self.disabled && self.isUseUndoRedo) {
          toolbarItems.push(
            {
              type: 'label',
              content: '<i class="v-icon notranslate mdi mdi-undo theme--light"/>' + (self.isShowIconDescription ? '<span class="toolbar_button">元に戻す</span>' : ''),
              onclick: function () { self.jspreadsheetObj.undo() },
              tooltip: '変更を戻します\n※行の追加/削除等、一部変更を戻せない場合もあります'
            },
            {
              type: 'label',
              content: '<i class="v-icon notranslate mdi mdi-redo theme--light"/>' + (self.isShowIconDescription ? '<span class="toolbar_button">やり直し</span>' : ''),
              onclick: function () { self.jspreadsheetObj.redo() },
              tooltip: '変更をやり直します'
            },
            { type: 'divisor' }
          )
        }
        if (!self.disabled && self.isUseAddRow) {
          if (self.isUseAddRowAbove) {
            toolbarItems.push(
              {
                type: 'label',
                content: '<i class="v-icon notranslate mdi mdi-table-row-plus-before theme--light"/>' + (self.isShowIconDescription ? '<span class="toolbar_button">上に挿入</span>' : ''),
                onclick: function () { self.rowAppendSingleAbove() },
                tooltip: '現在行の前に1行追加します'
              },
              {
                type: 'label',
                content: '<span style="display: flex; align-items: center;"><i class="v-icon notranslate material-icons theme--light" style="margin-right: 4px;">library_add</i>' + (self.isShowIconDescription ? '<span class="toolbar_button">複数行追加</span>' : '') + '</span>',
                onclick: function () { self.rowAppendDialog = true },
                tooltip: '選択行の前に、複数行追加します\n未選択の場合、最終行の後ろに複数行追加します'
              }
            )
          }
          if (self.isUseAddRowUnder) {
            toolbarItems.push(
              {
                type: 'label',
                content: '<i class="v-icon notranslate mdi mdi-table-row-plus-after theme--light"/>' + (self.isShowIconDescription ? '<span class="toolbar_button">下に挿入</span>' : ''),
                onclick: function () { self.rowAppendSingle() },
                tooltip: '現在行の後に1行追加します'
              }
            )
          }
          toolbarItems.push(
            { type: 'divisor' }
          )
        }
        if (self.isUseDeleteRow) {
          toolbarItems.push(
            {
              type: 'label',
              content: '<i class="v-icon notranslate mdi mdi-table-row-remove theme--light"/>' + (self.isShowIconDescription ? '<span class="toolbar_button">行を削除</span>' : ''),
              onclick: function () { self.rowDeleteSingle() },
              tooltip: '選択されている行を削除します。'
            },
            { type: 'divisor' }
          )
        }
        if (!self.disabled) {
          toolbarItems.push(
            {
              type: 'label',
              content: '<i class="v-icon notranslate mdi mdi-content-cut theme--light"/>' + (self.isShowIconDescription ? '<span class="toolbar_button">切り取り</span>' : ''),
              onclick: function () { jspreadsheetObj.cut(false) },
              tooltip: '選択したセルの切り取ってクリップボードにコピーし、\n他の場所に貼り付けられるようにします\n（[Ctrl+X]でも同様の事ができます）'
            },
            {
              type: 'label',
              content: '<i class="v-icon notranslate mdi mdi-content-copy theme--light"/>' + (self.isShowIconDescription ? '<span class="toolbar_button">コピー</span>' : ''),
              onclick: function () { jspreadsheetObj.copy(false) },
              tooltip: '選択したセルの内容をクリップボードにコピーし、\n他の場所に貼り付けられるようにします\n（[Ctrl+C]でも同様の事ができます）'
            },
            {
              type: 'label',
              content: '<i class="v-icon notranslate mdi mdi-content-paste theme--light"/>' + (self.isShowIconDescription ? '<span class="toolbar_button">貼り付け</span>' : ''),
              onclick: function () {
                if (jspreadsheetObj.selectedCell) {
                  navigator.clipboard.readText().then(function (text) {
                    if (text) {
                      jspreadsheetObj.paste(jspreadsheetObj.selectedCell[0], jspreadsheetObj.selectedCell[1], text)
                    }
                  })
                }
              },
              tooltip: 'クリップボードの内容を選択されているセルに貼り付けます\n（[Ctrl+V]でも同様の事ができます）'
            }
          )
        }
        if (self.isUseColorToolbar) {
          toolbarItems.push(
            { type: 'divisor' },
            // {
            //   type: 'color',
            //   content: 'format_color_text',
            //   k: 'color',
            //   tooltip: '文字色を設定します'
            // },
            {
              type: 'color',
              // content: 'format_color_fill',
              content: '<i class="v-icon notranslate mdi mdi-format-color-fill theme--light"/>' + (self.isShowIconDescription ? '<span class="toolbar_button">背景色</span>' : ''),
              k: 'background-color',
              class: 'dummy',
              tooltip: '選択したセルの背景色を設定します'
            }
          )

          // カラーピッカーをカスタマイズ
          setTimeout(() => {
            const colorButton = [...document.querySelectorAll('.jtoolbar-item')].find(item =>
              item.querySelector('i.mdi-format-color-fill')
            )

            if (colorButton) {
              colorButton.addEventListener('click', function (event) {
                event.preventDefault() // デフォルトの動作を無効化

                const defaultPalette = document.querySelector('.jcolor-content')
                if (defaultPalette) {
                  defaultPalette.style.display = 'none'
                }

                // 既存のカラーパレットを削除
                const existingPicker = document.querySelector('.custom-color-picker')
                if (existingPicker) {
                  existingPicker.remove()
                }

                // カスタムカラーパレットを作成
                const customPalette = ['#ffffff', '#c0c0c0', '#fffff0', '#ff0000', '#ffc0cb', '#0000ff', '#00bfff', '#87cefa', '#afeeee', '#00ced1', '#008000', '#90ee90', '#ffff00', '#ffa500', '#ffffe0']

                const paletteContainer = document.createElement('div')
                paletteContainer.className = 'custom-color-picker'
                paletteContainer.style.position = 'absolute'
                paletteContainer.style.top = `${colorButton.getBoundingClientRect().bottom + window.scrollY}px`
                paletteContainer.style.left = `${colorButton.getBoundingClientRect().left}px`
                paletteContainer.style.padding = '5px'
                paletteContainer.style.background = '#fff'
                paletteContainer.style.border = '1px solid #ccc'
                paletteContainer.style.display = 'flex'
                paletteContainer.style.flexWrap = 'wrap'
                paletteContainer.style.boxShadow = '0px 4px 6px rgba(0, 0, 0, 0.1)'
                paletteContainer.style.width = '155px'
                paletteContainer.style.zIndex = '1000'

                customPalette.forEach(color => {
                  const colorBox = document.createElement('div')
                  colorBox.style.backgroundColor = color
                  colorBox.style.width = '24px'
                  colorBox.style.height = '24px'
                  colorBox.style.margin = '2px'
                  colorBox.style.cursor = 'pointer'
                  colorBox.addEventListener('click', () => {
                    // セルの背景色を変更
                    const selectedRange = self.getActiveCell() // 選択範囲を取得
                    const styleObj = []
                    if (selectedRange.length > 0) {
                      const [startX, startY, endX, endY] = selectedRange
                      for (let y = startY; y <= endY; y++) {
                        const rr = self.jspreadsheetObj.getRowData(y)
                        for (let x = startX; x <= endX; x++) {
                          const columnName = self.column[x].name
                          if (self.setReadonlyCell && self.setReadonlyCell(rr, columnName)) {
                            continue
                          }
                          const cell = jSpreadSheet.helpers.getCellNameFromCoords(x, y)
                          // self.jspreadsheetObj.setStyle(cell, 'background-color', color)
                          styleObj[cell] = `background-color : ${color}`
                          self.$emit('changeStyleManually', cell)
                        }
                      }
                    }
                    if (styleObj) {
                      self.jspreadsheetObj.setStyle(styleObj)
                    }

                    // パレットを閉じる
                    paletteContainer.remove()
                    if (defaultPalette) {
                      defaultPalette.style.display = 'block'
                    }
                  })

                  paletteContainer.appendChild(colorBox)
                })

                document.body.appendChild(paletteContainer)

                // クリック外でカラーパレットを閉じる
                setTimeout(() => {
                  document.addEventListener('click', function closePalette (e) {
                    if (!paletteContainer.contains(e.target) && !colorButton.contains(e.target)) {
                      paletteContainer.remove()
                      document.removeEventListener('click', closePalette)
                    }
                  })
                }, 100)
              })
            }
          }, 500)
        }
        if (self.isUseControlToolbar) {
          toolbarItems.push(
            { type: 'divisor' },
            {
              type: 'label',
              content: '<i class="v-icon notranslate mdi mdi-reload theme--light"/>' + (self.isShowIconDescription ? '<span class="toolbar_button">再読み込み</span>' : ''),
              onclick: function () { self.onClickRefresh() },
              tooltip: '最新の情報を再読み込みします。'
            }
          )
        }
        if (self.isUseSaveToolbar) {
          toolbarItems.push(
            {
              type: 'label',
              content: '<i class="v-icon notranslate mdi mdi-content-save theme--light"/>' + (self.isShowIconDescription ? '<span class="toolbar_button">保存</span>' : ''),
              class: 'material-icons data-access',
              onclick: function () { self.onClickSave() },
              tooltip: '入力した内容で保存します。\n（変更箇所のみ反映されます）'
            }
          )
        }
        if (self.isUseDownloadToolbar) {
          toolbarItems.push(
            {
              type: 'label',
              content: '<i class="v-icon notranslate mdi mdi-download theme--light"/>' + (self.isShowIconDescription ? '<span class="toolbar_button">EXCEL出力</span>' : ''),
              onclick: function () {
                // jspreadsheet.download();
                self.onClickDownload()
              },
              tooltip: '一覧をEXCELファイルにダウンロードします'
            }
          )
        }
        if (self.isUseControlToolbar) {
          const expandText = (self.isShowIconDescription ? '<span class="toolbar_button">全画面表示</span>' : '')
          const collapseText = (self.isShowIconDescription ? '<span class="toolbar_button">全画面終了</span>' : '')
          toolbarItems.push(
            {
              type: 'label',
              content: '<i class="v-icon notranslate mdi mdi-arrow-expand-all theme--light"/>',
              onclick: function (a, b, c) {
                // アイコン部分の要素を取得
                const iconElement = c.children[0]

                if (iconElement.classList.contains('mdi-arrow-expand-all')) {
                  jspreadsheetObj.fullscreen(true)
                  self.isFullScreen = true

                  // クラスを変更して全画面用のアイコンに切り替え
                  iconElement.classList.remove('mdi-arrow-expand-all')
                  iconElement.classList.add('mdi-arrow-collapse-all')

                  if (![undefined, null, ''].includes(self.spreadDescription)) {
                    if ([undefined, null].includes(document.querySelector('div.jss_sub_description'))) {
                      const conditionElement = document.querySelector('div.jtabs-content')
                      const newElement = document.createElement('div')
                      newElement.className = 'jss_sub_description'
                      newElement.innerHTML = self.spreadDescription
                      conditionElement.before(newElement)
                    }
                  }
                } else {
                  jspreadsheetObj.fullscreen(false)
                  self.isFullScreen = false

                  // クラスを変更して通常画面用のアイコンに切り替え
                  iconElement.classList.remove('mdi-arrow-collapse-all')
                  iconElement.classList.add('mdi-arrow-expand-all')

                  if (![undefined, null, ''].includes(self.spreadDescription)) {
                    const conditionElement = document.querySelector('div.jss_sub_description')
                    if (![undefined, null].includes(conditionElement)) {
                      conditionElement.remove()
                    }
                  }
                }
              },
              tooltip: '画面表示の切り替え（全画面⇔標準）',
              updateState: function (a, b, c, d) {
                if (d.parent.config.fullscreen) {
                  c.children[0].innerHTML = collapseText
                } else {
                  c.children[0].innerHTML = expandText
                }
              }
            }
          )
        }
        if (self.customToolbarItem) {
          toolbarItems.push(...self.customToolbarItem)
        }
        option.toolbar = toolbarItems
      }
      // 編集可否
      option.locked = self.disabled
      // フッター
      option.footers = self.footer || null
      // ヘッダー
      option.columns = JSON.parse(JSON.stringify(self.computedColumns)) || []
      // ヘッダーの一段目
      option.nestedHeaders = self.nestedHeaders || null
      // 内容 はじめは空じゃないとインスタンス化する時に勝手にヘッダ作られることがある
      option.data = []
      // コンテキストメニュー
      option.contextMenu = self.setContextMenu || null
      // イベント
      // onbeforechange?: (worksheet: worksheetInstance, cell: HTMLElement, x: number, y: number, value: any) => boolean | any;
      option.onbeforechange = function (worksheet, cell, x, y, value) {
        // console.log('onbeforechange', worksheet, cell, x, y, value)
        // 変更されてないなら変更しない delete二回でカスタマイズしたセルが消え去ることがあることへの対策
        const cellName = jSpreadSheet.helpers.getCellNameFromCoords(x, y)
        const oldValue = self.jspreadsheetObj.getValue(cellName)
        if ((oldValue === null || oldValue === '') && (value === null || value === '')) { return false }
        var returnValue
        // 補完処理
        const column = self.getColumnCustom(x)
        if (column.complement) { returnValue = self.getComplementValue(x, value) }
        // complement処理があるセルで同じ値になる入力を行うとchangeイベントまで進まずカスタマイズしたセルが消え去る
        if (oldValue === returnValue) {
          // セル設定し直し 特殊なことやってるセル向け
          option.oncreatecell(worksheet, cell, x, y, returnValue)
          return false
        }
        return returnValue
      }
      // onchange?: (worksheet: worksheetInstance, cell: HTMLElement, x: number, y: number, newValue: any, oldValue: any) => void;
      option.onchange = function (worksheet, cell, x, y, newValue, oldValue) {
        console.log('onchange', worksheet, cell, x, y, newValue, oldValue)
        // 選択セルを取得
        self.selectedCell = self.jspreadsheetObj.selectedCell
        // // データ読み込み直し
        // self.loadData()
        // セル設定し直し 特殊なことやってるセル向け
        option.oncreatecell(worksheet, cell, x, y, newValue)
        if (self.selectedCell != null) {
          // 初期表示時や外部から表データを弄った時は選択セルがないから存在確認
          const left = self.selectedCell[0] || 0
          const top = self.selectedCell[1] || 0
          const right = self.selectedCell[2] || 0
          const bottom = self.selectedCell[3] || 0
          // 選択セルを選択し直す（表を作り直してるから選択解除になっている）
          self.jspreadsheetObj.updateSelectionFromCoords(left, top, right, bottom)
        }
        // エラー設定
        self.validateSetError(x, y, newValue)
        self.setErrorCell(x, y)
        /*
        if (!self.setErrorCell(x, y)) {
          // 編集設定
          self.setEdited(x, y)
        }
        */
        self.setEdited(x, y)

        var rowData = self.computedDatasNotDelete[y] || {}
        self.$emit('changeAfter', rowData, cell, x, y, newValue, oldValue)
      }
      // クリックイベントハンドラー
      // ツールバーでの前画面切り替えクリックのみ
      // onclick?: (worksheet: worksheetInstance, section: string, x: number, y: number, event: object) => void;
      option.onclick = function (worksheet, section, x, y, event) {
        console.log('onclick', worksheet, section, x, y, event)
        if (section === 'toolbar' && !event) { return }
        const target = event.target
        // クリックされたツールバーボタンを特定
        const closest = target.closest('.jtoolbar-item')
        const innerText = closest ? closest.innerText : null
        if (innerText === 'fullscreen') {
          // 全画面表示
          event.stopPropagation()
          if (self.isUseMinDimensions) {
            worksheet.setConfig({
              ...self.option,
              fullscreen: true,
              allowInsertColumn: true,
              minDimensions: [0, 50]
            })
          } else {
            worksheet.setConfig({
              ...self.option,
              fullscreen: true
            })
          }
          self.loadData()
        } else if (innerText === 'fullscreen_exit') {
          // 全画面解除
          event.stopPropagation()
          worksheet.setConfig({
            ...self.option,
            fullscreen: false,
            allowInsertColumn: false,
            minDimensions: [0, 0]
          })
          self.jspreadsheetObj.loadData(self.value)
        }
      }
      // onpaste?: (worksheet: worksheetInstance, records: Array<any>) => void;
      option.onpaste = function (worksheet, records) {
        // console.log('onpaste', worksheet, records)
        // oncreatecellでやってることが動いてほしい
        records.forEach(elem => {
          const cell = self.jspreadsheetObj.getCellFromCoords(elem.x, elem.y)
          option.oncreatecell(worksheet, cell, elem.x, elem.y, elem.value)
        })
      }
      // oncreaterow?: (worksheet: worksheetInstance, rowNumber: number, tr: HTMLElement) => void;
      option.oncreaterow = function (worksheet, rowNumber, tr) {
        // console.log('oncreaterow', worksheet, rowNumber, tr)
        // 外部のエラー設定 主に行項番に対して
        self.setOutsideErrorList()
        self.$emit('rowAddAfter', rowNumber)
      }
      // oncreatecell?: (worksheet: worksheetInstance, cell: HTMLElement, x: number, y: number, value: any) => void;
      option.oncreatecell = function (worksheet, cell, x, y, value) {
        // console.log('oncreatecell', worksheet, cell, x, y, value)
        // カスタマイズ項目の設定
        self.setCustomCell(worksheet, cell, x, y, value)
        // エラー設定
        self.setErrorCell(x, y)
        // 部品呼び出し元で各セルの読み取り状態を制御したいなら制御する
        if (self.setReadonlyCell) {
          var rowData = self.computedDatasNotDelete[y]
          if (!rowData) { return }
          if (!self.column[x]) { return }
          var columnName = self.column[x].name
          var cellName = jSpreadSheet.helpers.getCellNameFromCoords(x, y)
          var isReadonly = self.setReadonlyCell(rowData, columnName)
          if (self.column[x].type === 'customIconButton' || self.column[x].type === 'customIconButtonCond') {
            isReadonly = null
          }
          if (isReadonly != null && self.jspreadsheetObj) {
            // nullの場合は何もしない 列項目情報の通り読み取り状態を設定する
            const ws = self.jspreadsheetObj.getWorksheetActive()
            const wss = self.jspreadsheetObj.getWorksheetInstance(ws)
            wss.setReadOnly(cellName, isReadonly)
          }
        }
      }
      // onselection?: (worksheet: worksheetInstance, px: number, py: number, ux: number, uy: number, origin?: object) => void;
      option.onselection = function (worksheet, px, py, ux, uy, origin) {
        // 現在セルの取得
        self.selectedCell = self.jspreadsheetObj.selectedCell
        // console.log('onselection', worksheet, px, py, ux, uy, origin)
        // 左上セル側のスクロールの挙動がいまいちなので最も上と最も左のセルフォーカス時のスクロールを調整

        // マウスクリック時のセルフォーカスイベントなので無視
        if (origin !== undefined) { return }

        const content = worksheet.content
        if (content) {
          // 最も上
          if (py === 0) { content.scrollTop = 0 }
          // 最も左
          if (px === 0) { content.scrollLeft = 0 }
        }
      }

      // onsort?: (worksheet: worksheetInstance, column: number, direction: number, newOrderValues: []) => void;
      option.onsort = function (worksheet, column, direction, newOrderValues) {
        self.$emit('sort', worksheet, column, direction, newOrderValues)
      }

      option.onmoverow = function (instance, from, to) {
        self.$emit('moverow', instance, from, to)
      }
      // インスタンス化
      jSpreadSheet.license = self.license

      // 関数拡張
      jSpreadSheet.setExtensions({ formula })
      // jSpreadSheet.dataType = 1
      // jSpreadSheet.sequence = false
      // 表示文字列変換
      jSpreadSheet.setDictionary({
        Show: '1ページ当たりの行数 :',
        entries: ' ',
        'Showing page {0} of {1} entries': '全部で {1} ページあります',
        Search: 'さらにフリーワードで絞り込む ',
        'No records found': '対象データがありません',
        // filter機能
        'Select all': 'すべて選択',
        Blanks: '空白',
        Contains: '含む',
        'Does not contain': '含まない',
        'Begins with': '前方一致',
        'Ends with': '後方一致',
        Equal: '一致',
        'Not equal': '不一致',
        'Greater than': '以上',
        'Lower than': '以下',
        'No matches': '該当なし',
        RESET: 'クリア',
        DONE: '閉じる',
        Update: '更新',
        Ok: 'OK'
      })
      const jspreadsheetObj = jSpreadSheet(
        // DOM参照
        self.$refs.spreadsheet,
        // 表の設定データ
        option
      )
      // オブジェクトから thisに対してコピー
      Object.assign(self, { jspreadsheetObj })
      // データバインド
      self.jspreadsheetObj.data = self.computedDatasNotDelete
      // 項番列表示制御
      if (!self.isDisplayIndex) {
        self.jspreadsheetObj.hideIndex()
      }
      // 値描画
      self.loadData()

      // jss_contentのwheelイベントがスクロール時の挙動を不安定にさせている ブラウザとの相性問題かも
      // 親要素にキャプチャリングフェーズ（親から子へ伝搬させるので親が先に動く）のイベントを追加することで制御
      const ref = self.$refs.spreadsheet
      ref.addEventListener('wheel', (event) => {
        // とりあえず無条件で伝搬止めることで許容できそうな挙動になった
        event.stopPropagation()
      }, true)

      // 戻る機能とやり直す機能は不都合になりがちなので無効化
      // this.jspreadsheetObj.ignoreHistory = true
      // jSpreadSheet.history.undo = function () { return true }
      // jSpreadSheet.history.redo = function () { return true }

      // // カスタム入力項目であってもペーストできるように上書き
      // this.jspreadsheetObj.paste = this.pasteOverride
      // // カスタム入力項目であっても切り取りできるように上書き
      // jSpreadSheet.cutControls = this.cutControlsOverride
      // // ヘッダーが一段じゃなかったりするとおかしくなるスクロールを調整（特に矢印ボタンでの移動）
      // this.jspreadsheetObj.updateScroll = this.updateScrollOverride
    },
    reSetSpreadSheet: function () {
      // refsで親画面から起動
      console.log('reSetSpreadSheet', this.jspreadsheetObj)
      if (this.jspreadsheetObj) { jSpreadSheet.destroy(this.jspreadsheetObj.parent.element, false) }
      this.setSpreadSheet()
      return false
    },
    loadData: function () {
      // loadDataはchangeが発生しない
      console.log('loadData', this.computedDatasNotDelete)
      if (this.jspreadsheetObj) {
        // 一覧→編集画面遷移時にヘッダーやらフッターやら一気に設定しようとすると渋滞を起こすのか待ってあげるとうまく描画される
        const handle = requestAnimationFrame(() => {
          this.jspreadsheetObj.loadData(this.computedDatasNotDelete)
          cancelAnimationFrame(handle)
          this.$nextTick(() => {
            // データ読み込み描画終了
            this.isLoading = false
            // 一括エラー判定
            this[controls.VALIDATE_METHOD]()
            // if (iReason !== 3) {
            this.$nextTick(() => {
              this.$emit('loadDataAfter')
            })
            // }
          })
        })
      }
    },
    updateSelectionFromCoords: function (left, top, right, bottom) {
      // refsで親画面から起動可能
      // console.log('updateSelectionFromCoords', left, top, right, bottom)
      return this.jspreadsheetObj.updateSelectionFromCoords(left, top, right, bottom)
    },
    setCustomCell: function (worksheet, cell, x, y, value) {
      if (!this.jspreadsheetObj) { return }

      // console.log('setCustomCell', worksheet, cell, x, y, value)
      const row = this.jspreadsheetObj.getRowData(y)
      if (!row) { return }
      const column = this.getColumnCustom(x)
      if (!column) { return }
      // 表示フォーマットのみの上書き(customDate型のアイコン付与・編集ポップアップは伴わない軽量処理)
      // customDate型の場合はsetCustomCellDate側で改めて上書きされるためここでは対象外
      if (column.type !== 'customDate' && column.customDateFormat && typeof value === 'string' && dayjs(value, 'YYYY/MM/DD', true).isValid()) {
        cell.innerHTML = dayjs(value).format(column.customDateFormat)
      }
      if (column.type === 'customDate') {
        this.setCustomCellDate(cell, x, y, value, row)
      } else if (column.type === 'customIconButton') {
        this.setCustomCellIconButton(cell, x, y, value, row)
      } else if (column.type === 'customIconButtonCond') {
        this.setCustomCellIconButtonOnCondition(cell, x, y, value, row)
      } else {
        // 非共通 個別設定
        // if (column.type !== 'custom') { return }
        if (column.setCustomCell) {
          column.setCustomCell(cell, x, y, value, row)
        }
      }
      // columnが不一致となるセルに対する処置 データ一行分を複数行に改造したり、セル結合している場合を想定
      this.$emit('setCustomCell', cell, x, y, value, row, column)
    },
    onChange: function (worksheet, cell, x, y, newValue, oldValue) {
      console.log('onchange', worksheet, cell, x, y, newValue, oldValue)
      // 選択セルを取得
      this.selectedCell = this.jspreadsheetObj.selectedCell
      // // データ読み込み直し
      // self.loadData()
      // セル設定し直し 特殊なことやってるセル向け
      this.onCreateCell(worksheet, cell, x, y, newValue)
      if (this.selectedCell != null) {
        // 初期表示時や外部から表データを弄った時は選択セルがないから存在確認
        const left = this.selectedCell[0] || 0
        const top = this.selectedCell[1] || 0
        const right = this.selectedCell[2] || 0
        const bottom = this.selectedCell[3] || 0
        // 選択セルを選択し直す（表を作り直してるから選択解除になっている）
        this.jspreadsheetObj.updateSelectionFromCoords(left, top, right, bottom)
      }
      // エラー設定
      this.validateSetError(x, y, newValue)
      this.setErrorCell(x, y)
    },
    onCreateCell: function (worksheet, cell, x, y, value) {
      console.log('oncreatecell', worksheet, cell, x, y, value)
      // カスタマイズ項目の設定
      this.setCustomCell(worksheet, cell, x, y, value)
      // エラー設定
      this.setErrorCell(x, y)
      // 部品呼び出し元で各セルの読み取り状態を制御したいなら制御する
      if (this.setReadonlyCell) {
        var rowData = this.computedDatasNotDelete[y]
        if (!rowData) { return }
        const column = this.getColumnCustom(x)
        var columnName = column.name
        var cellName = jSpreadSheet.helpers.getCellNameFromCoords(x, y)
        var isReadonly = this.setReadonlyCell(rowData, columnName)
        if (self.column[x].type === 'customIconButton' || self.column[x].type === 'customIconButtonCond') {
          isReadonly = null
        }
        if (isReadonly != null) {
          // nullの場合は何もしない 列項目情報の通り読み取り状態を設定する
          const ws = this.jspreadsheetObj.getWorksheetActive()
          const wss = this.jspreadsheetObj.getWorksheetInstance(ws)
          wss.setReadOnly(cellName, isReadonly)
        }
      }
    },
    /*
     * validate検証処理
     */
    validate: function (x, value) {
      console.log('validate')
      // 検証処理
      var target = {}
      var msg = null
      // ヘッダーから項目の情報を取得してvalidate処理を取得・設定
      const column = this.getColumnCustom(x)
      if (!column) { return }
      // 必須確認
      if (column.required) {
        target.value = value
        msg = validators.requireValidate(target)
        if (msg !== undefined) {
          // 検証処理でerror
          return { isErr: true, msg: msg }
        }
      }
      // 入力タイプ別検証処理
      var validatorList = []
      target = column.validInfo || {}

      if (target) {
        const list = controls.getInputTypeValidators(controls.InputTypes[target.inputType])
        validatorList = validatorList.concat(list)
      }

      if (validatorList.length > 0) {
        target.value = value
        // 必須確認じゃないから値がないなら検証処理しない で良いはず
        if ([null, ''].includes(target.value)) { return false }
        // 日付項目独自処理
        if (target.validateType === 'Date') {
          // 標準のcalendarでは日付項目がハイフン区切りのことがあるためスラッシュ区切りに変換してから検証処理を行う
          target.value = filter.dateFormatter(value)
        } else if (column.validateType === 'Time' || column.validateType === 'TimeSpan') {
          // なぜか数値は数値変換されてしまうので
          target.value = target.value + ''
        }

        for (let i = 0; i < validatorList.length; i++) {
          const f = validatorList[i]
          msg = f(target)
          if (msg !== undefined) {
            // 検証処理でerror
            return { isErr: true, msg: msg }
          }
          if (i === validatorList.length - 1) {
            // すべての検証処理でerrorなし
            return false
          }
        }
      } else {
        return false
      }
    },
    customValidate: function (x, value) {
      // ヘッダー項目情報を取得
      const column = this.getColumnCustom(x)
      if (!column) { return false }
      if (column.validateType === 'Time') {
        if ([undefined, null, ''].includes(value)) { return false }
        // 時間フォーマットチェック（HH:mm:ss/HH:mmが標準validateにない）
        const fixedTimeValue = this.normalizeTime(value)
        if (!dayjs(fixedTimeValue, 'HH:mm:ss', true).isValid() && !dayjs(fixedTimeValue, 'HH:mm', true).isValid()) {
          // 検証処理でerror
          return { isErr: true, msg: message.get('COMV0014') }
        } else {
          return false
        }
      } else {
        return false
      }
    },
    normalizeTime: function (value) {
      // H:MM または HH:MM 形式にマッチ
      const m = value.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?$/)
      if (!m) return value

      const hh = m[1].padStart(2, '0') // 1桁でも2桁にゼロ埋め
      const mm = m[2]
      const ss = m[3] ? `:${m[3]}` : ''
      return `${hh}:${mm}${ss}`
    },
    validateSetError: function (x, y, value) {
      const self = this
      const column = this.getColumnCustom(x)
      if (!column) { return }
      var columnName = column.name
      var data = self.validate(x, value)
      var data2 = self.customValidate(x, value)
      var data3 = self.setRequired(x, y, value)
      // 同じセルのエラーは一度削除して更新
      self.errorList = self.errorList.filter(elem => !(elem.columnName === columnName && Number(elem.y) === Number(y)))
      if (data.isErr) {
        var errorRow = {
          y: y,
          columnName: columnName,
          msg: data.msg
        }
        self.errorList.push(errorRow)
      } else if (data2.isErr) {
        var errorRow2 = {
          y: y,
          columnName: columnName,
          msg: data2.msg
        }
        self.errorList.push(errorRow2)
      } else if (data3.isErr) {
        var errorRow3 = {
          y: y,
          columnName: columnName,
          msg: data3.msg
        }
        self.errorList.push(errorRow3)
      }
      if (data3.isErr === false) {
        self.errorList = self.errorList.filter(f => {
          return !(f.y === y && f.columnName === columnName && f.msg === data3.msg)
        })
      }
    },
    setRequired: function (x, y, value) {
      // console.log('setRequired', x, y, value)
      const self = this
      if (!self.setRequiredCell) { return false }
      var rowData = self.computedDatasNotDelete[y]
      if (!rowData) { return false }
      const column = self.getColumnCustom(x)
      if (!column) { return false }
      var columnName = column.name
      // 部品呼び出し元で各セルの必須状態を制御する
      var isRequired = self.setRequiredCell(rowData, columnName)
      var msg = validators.requireValidate({ value: value })
      if (msg !== undefined && isRequired != null) {
        return {
          isErr: isRequired,
          msg: msg
        }
      }
      return false
    },
    // validateAllで呼ばれるように 中身は入力項目すべてをvalidate
    [controls.VALIDATE_METHOD]: function () {
      console.log('[controls.VALIDATE_METHOD] spreadSheet')
      const self = this
      // 全セルに対するエラーを更新
      if (!self.jspreadsheetObj) {
        return
      }
      var data = self.jspreadsheetObj.getData(false, false, null, false)
      // 一度初期化してからやり直す
      self.errorList = []
      data.forEach((row, y) => {
        row.forEach((value, x) => {
          self.validateSetError(x, y, value)
          self.setErrorCell(x, y)
        })
      })
    },
    [controls.GET_INVALID_METHOD]: function () {
      // console.log('[controls.GET_INVALID_METHOD] spreadsheet')
      if (this.computedOutsideErrorListCnt > 0) {
        return false
      }

      if (this.isManageEditFlg) {
        // 変更行のみチェックする
        const editRows = this.value.map((item, index) => {
          item.y = index
          return item
        }).filter(item => {
          return item.editFlg === true
        }).map(item => {
          return item.y
        })
        const errrec = this.computedErrorList.filter(elem => editRows.includes(elem.y))
        if (errrec.length > 0) {
          return false
        } else {
          return undefined
        }
      } else {
        // 編集フラグがない場合は通常通りエラー有無チェック
        if (this.computedErrorListCnt > 0) {
          return false
        } else {
          return undefined
        }
      }
    },
    [controls.CLEAR_INVALID_METHOD]: function () {
      this.errorList = []
      // this.reSetSpreadSheet()
    },
    /*
     * エラー設定
     */
    setErrorCell: function (x, y) {
      if (!this.isEnableSetErrorCell) { return }

      var errorFlg = false

      const self = this
      const column = this.getColumnCustom(x)
      if (!column) { return }
      // コメントが消去されてしまうのでそれを避けたいのなら 読み取り専用の特別なセルを想定
      if (column.isNoSetError) { return }
      var columnName = column.name
      var columnPositionX = self.jspreadsheetObj.getColumnIdByName(columnName)

      var cellName = jSpreadSheet.helpers.getCellNameFromCoords(columnPositionX, y)
      var cell = self.jspreadsheetObj.getCell(cellName)
      if (!cell) { return }
      // var error = self.errorList.find(elem => elem.cellName === cellName)
      var error = self.errorList.find(elem => elem.columnName === columnName && elem.y === y)
      if (error !== undefined) {
        cell.classList.add('errorCell')
        // self.jspreadsheetObj.setComments(cellName, error.msg)
        cell.setAttribute('title', error.msg)
        errorFlg = true
      } else {
        cell.classList.remove('errorCell')
        // self.jspreadsheetObj.setComments(cellName, null)
        cell.removeAttribute('title')
      }
      return errorFlg
    },
    /**
     * 編集設定
     */
    setEdited: function (x, y) {
      const self = this
      const column = this.getColumnCustom(x)
      if (!column || column.readOnly === true) { return }
      if (y >= self.value.length) { return }
      // console.log('setEdited : ', self.computedDatasNotDelete[y], self.value)
      const errIdx = self.errorList.findIndex(elem => elem.y === y)
      if (errIdx >= 0) {
        self.computedDatasNotDelete[y].errFlg = true
        self.computedDatasNotDelete[y].editFlg = true
      } else {
        // エラーフラグ初期化
        self.computedDatasNotDelete[y].errFlg = false

        if (self.computedDatasNotDelete[y].editFlg !== 'undefined') {
          self.computedDatasNotDelete[y].editFlg = true

          // 変更セルの背景色変更
          if (!self.isDisabledChangeEmphasis) {
            var cellName = jSpreadSheet.helpers.getCellNameFromCoords(x, y)
            var cell = self.jspreadsheetObj.getCell(cellName)
            if (cell !== undefined) {
              cell.classList.add('changeCell')
            }
          }
        }
      }
    },
    // 外部からエラーを設定 主にAPIエラーの結果を行に反映したい時に
    setOutsideErrorList: function () {
      if (!this.jspreadsheetObj) { return }

      const rows = this.jspreadsheetObj.rows
      const dataCurrentOrder = this.valueCurrentOrder
      this.outsideErrorList.forEach(error => {
        // rowIdじゃなくてyとかが良さそうだなあ
        // const y = dataCurrentOrder.find(elem => elem.y === Number(error.rowId))?.currentIndex || 0
        const y = dataCurrentOrder.findIndex(elem => elem.y === Number(error.rowId))
        var find = rows.find(elem => elem.y === y)
        if (find !== undefined) {
          if (find.element) {
            var targetCell = null
            if (error.x === -1) {
              // 項番セル
              targetCell = find.element.querySelector('td.jss_row')
              if (targetCell) {
                // titleを設定することでコメント扱いになるらしい
                targetCell.setAttribute('title', error.msg)
                targetCell.classList.add('errorCell')
              }
            } else {
              // 項番セル
              targetCell = find.element.querySelector(`[data-x="${error.x}"]`)
              if (targetCell) {
                // titleを設定することでコメント扱いになるらしい
                targetCell.setAttribute('title', error.msg)
                targetCell.classList.add('errorCell')
              }
            }
          }
        }
      })
    },
    removeOutsideErrorList: function (oldErrorList) {
      const rows = this.jspreadsheetObj.rows
      const dataCurrentOrder = this.valueCurrentOrder
      oldErrorList.forEach(error => {
        // rowIdじゃなくてyとかが良さそうだなあ
        // const y = dataCurrentOrder.find(elem => elem.y === Number(error.rowId))?.currentIndex || 0
        const y = dataCurrentOrder.findIndex(elem => elem.y === Number(error.rowId))
        var find = rows.find(elem => elem.y === y)
        if (find !== undefined) {
          if (find.element) {
            var targetCell = null
            if (error.x === -1) {
              // 項番セル
              targetCell = find.element.querySelector('td.jss_row')
              if (targetCell) {
                // titleを設定することでコメント扱いになるらしい
                targetCell.removeAttribute('title')
                targetCell.classList.remove('errorCell')
              }
            } else {
              // 項番セル
              targetCell = find.element.querySelector(`[data-x="${error.x}"]`)
              if (targetCell) {
                // titleを設定することでコメント扱いになるらしい
                targetCell.removeAttribute('title')
                targetCell.classList.remove('errorCell')
              }
            }
          }
        }
      })
    },
    // sort等による実際の並び順のデータ
    getDataCurrentOrder () {
      return this.computedDatasNotDelete.map((elem, index) => {
        var spreadSheetRowData = this.jspreadsheetObj.getRowData(index)
        // 確実に判別できそうな項目がなかったので全部で比較 idがユニークとしてちゃんと使われるかもわからないし…どこかで付与する方法もありそうだけど…
        var result = this.computedDatasNotDelete.find(row => JSON.stringify(row) === JSON.stringify(spreadSheetRowData))
        return result
      })
    },
    // 外部からフィルターを設定したいときに
    setOutsideFiltersList: function () {
      if (!this.jspreadsheetObj) { return }

      const ws = this.jspreadsheetObj.getWorksheetActive()
      const wss = this.jspreadsheetObj.getWorksheetInstance(ws)
      const fil2 = wss.getFilter()
      const fil = Object.entries(fil2)
      wss.resetFilters()

      this.outsideFiltersList.forEach(f => {
        wss.setFilter(f.key, f.value)
      })
      fil.forEach(x => {
        if (!this.outsideFiltersList.find(z => { return Number(z.key) === Number(x[0]) })) {
          if (x[1] != null) {
            wss.setFilter(Number(x[0]), x[1])
          }
        }
      })
    },
    /*
     * 補完処理
     */
    getComplementValue: function (x, value) {
      // console.log('getComplementValue', x)
      // ヘッダーから項目の情報を取得してcomplement処理を実施
      const column = this.getColumnCustom(x)
      // 補完処理（メソッド）
      return column.complement(`${value}`)
    },
    /*
     * その他
     */
    getColumnCustom: function (x) {
      if (!this.jspreadsheetObj) { return }

      // 主に項目列移動をした際にxと項目列情報が一致しなくなるのでそれ対策

      // 座標から対象の項目列情報を取得
      const targetColumn = this.jspreadsheetObj.getColumn(x)
      // 項目列情報に色々付与していることがあるので取得し直す
      const column = this.computedColumns.find(elem => elem.name === targetColumn.name)
      return column
    },
    onContext: function () {
      // スプレッドシートには右クリックがあるためブラウザの右クリックは禁止
      event.preventDefault()
    },
    /* スプレッドシート コンテキストメニュー--> */
    setContextMenu: function (obj, x, y, e) {
      console.log('setContextMenu', obj, x, y, e)
      // 読み取りモードならコンテキストメニュー出さない
      if (this.isShoukaiMode) { return false }

      const self = this
      var items = []
      // 各種機能
      var insert = null
      var del = null
      var clear = null
      var cut = null
      var copy = null
      var paste = null
      var edit = null
      var merge = null
      var custom1 = null
      // 区切り線
      var line = { type: 'line' }

      if (y === null) {
        // ヘッダー選択
      }
      if (y !== null) {
        // ヘッダー選択以外

        // 選択行数判定
        var selectedRowCnt = obj.getSelectedRows().length
        if (selectedRowCnt === 1) {
          // 1行のみ選択されている場合
          // 編集
          if (self.isUseEditRow) {
            edit = {
              title: '編集',
              onclick: function () {
                // 行追加後の行特定ID、行追加が実行された行データ、行番号を渡す toDoここいらなくなるはず
                // var maxRowIdForSS = Math.max(...self.value.map(m => m.rowIdForSS)) + 1
                // 行追加時はfilterをリセットする
                // self.jspreadsheetObj.resetFilters()
                // self.$emit('addRow', maxRowIdForSS, self.value[y], y)
                // 行追加された行を渡す
                self.$emit('edit', Number(y))
              }
            }
          }
          // クリア
          if (self.isUseClearRow) {
            // 行クリア使用
            var isDispClearRow = true
            if (self.isUseClearRowForEachLine != null) {
              // 各行に対する判定メソッドがある
              if (!self.isUseClearRowForEachLine(self.value[y])) {
                isDispClearRow = false
              }
            }
            if (isDispClearRow) {
              clear = {
                title: '行クリア',
                onclick: function () {
                  // // 行削除対象のエラーを削除
                  // const rowId = self.value[y].rowIdForSS ? self.value[y].rowIdForSS.toString() : 0
                  // self.errorList = self.errorList.filter(elem => !(elem.rowId === rowId))
                  // 行クリアが実行された行データを渡す
                  self.$emit('clearRow', self.value[y])
                }
              }
            }
          }
        }
        // 追加
        if (self.isUseAddRow) {
          // 行追加使用
          var isDispAddRow = true
          if (self.isUseAddRowForEachLine != null) {
            // 各行に対する判定メソッドがある
            if (!self.isUseAddRowForEachLine(self.value[y])) {
              isDispAddRow = false
            }
          }
          if (isDispAddRow) {
            insert = {
              title: '行追加',
              onclick: function () {
                // 行追加後の行特定ID、行追加が実行された行データ、行番号を渡す toDoここいらなくなるはず
                // var maxRowIdForSS = Math.max(...self.value.map(m => m.rowIdForSS)) + 1
                // 行追加時はfilterをリセットする
                // self.jspreadsheetObj.resetFilters()
                // self.$emit('addRow', maxRowIdForSS, self.value[y], y)
                // 行追加された行を渡す
                self.$emit('addRowAbove', Number(y))
              }
            }
          }
        }
        // 削除
        if (self.isUseDeleteRow) {
          // 行削除使用
          var isDispDeleteRow = true
          if (self.isUseDeleteRowForEachLine != null) {
            // 各行に対する判定メソッドがある
            if (!self.isUseDeleteRowForEachLine(self.value[y])) {
              isDispDeleteRow = false
            }
          }
          if (isDispDeleteRow) {
            del = {
              title: '行削除',
              onclick: function () {
                // 行削除対象のエラーを削除
                // const rowId = self.value[y].rowIdForSS ? self.value[y].rowIdForSS.toString() : 0
                // self.errorList = self.errorList.filter(elem => !(elem.rowId === rowId))
                // 行削除が実行された行データを渡す
                // self.$emit('deleteRow', self.value[y])
                // 行削除が実行された行を渡す
                self.$emit('deleteRow', 1, Number(y))
              }
            }
          }
        }

        // カスタム追加アイテム（※emitは選択している行のリストを返す）
        if (![undefined, null].includes(self.customContextMenuItem)) {
          custom1 = {
            title: self.customContextMenuItem.title,
            onclick: function () {
              self.$emit(self.customContextMenuItem.eventNm, obj.getSelectedRows())
            }
          }
        }
      }
      // 結合
      if (self.isUseMergeCell) {
        merge = {
          title: '結合',
          onclick: function () {
            var selectedRange = obj.getSelected()
            if (selectedRange) {
              // 選択範囲の開始座標と終了座標を分解
              var start = selectedRange[0]
              var end = selectedRange[selectedRange.length - 1]
              var currentCell = jSpreadSheet.helpers.getCellNameFromCoords(start.x, start.y)
              obj.setMerge(currentCell, (end.x - start.x) + 1, (end.y - start.y) + 1)
            }
          }
        }
      }
      // 切り取り
      cut = {
        title: '切り取り',
        shortcut: 'Ctrl + X',
        onclick: function () {
          obj.cut(false)
        }
      }
      // コピー
      copy = {
        title: 'コピー',
        shortcut: 'Ctrl + C',
        onclick: function () {
          obj.copy(false)
        }
      }
      // 貼り付け
      if (navigator && navigator.clipboard && navigator.clipboard.readText) {
        // コピー済？
        paste = {
          title: '貼り付け',
          shortcut: 'Ctrl + V',
          onclick: function () {
            if (obj.selectedCell) {
              navigator.clipboard.readText().then(function (text) {
                if (text) {
                  obj.paste(obj.selectedCell[0], obj.selectedCell[1], text)
                }
              })
            }
          }
        }
      }

      // コンテキストメニュー内容設定
      if (insert !== null) { items.push(insert) }
      if (edit !== null) { items.push(edit) }
      if (del !== null) { items.push(del) }
      if (clear !== null) { items.push(clear) }
      if (merge !== null) { items.push(merge) }
      if (custom1 !== null) { items.push(line) }
      if (custom1) { items.push(custom1) }
      if (insert !== null || del !== null) { items.push(line) }
      if (cut) { items.push(cut) }
      if (copy) { items.push(copy) }
      if (paste !== null) { items.push(paste) }
      return items
    },
    /*
     * 日付項目
     */
    setCustomCellDate: function (cell, x, y, value, rowData) {
      // console.log('setCustomCellDate')
      const column = this.getColumnCustom(x)
      // 表示形式を定義できるようにする
      if (column.customDateFormat) {
        if (typeof value === 'string' && dayjs(value, 'YYYY/MM/DD', true).isValid()) {
          cell.innerHTML = dayjs(value).format(column.customDateFormat)
        }
      }
      if (column.readOnly) { return }
      const self = this
      cell.style.position = 'relative'

      var icon = document.createElement('i')
      icon.classList.add('mdi')
      icon.classList.add('mdi-calendar')
      icon.classList.add('primary--text')
      icon.style.cursor = 'pointer'
      icon.style.fontSize = '18px'
      icon.style.position = 'absolute'
      icon.style.top = '50%'
      icon.style.transform = 'translateY(-50%)'
      icon.style.right = 0
      icon.onclick = function (e) {
        // 入力項目に値をセット
        self.inputDate = value
        // クリックされた行特定情報を保持
        self.selectedId = rowData.id
        // クリックされたセル位置情報を保持
        self.selectedX = x
        self.selectedY = y
        // 日付ピッカーの位置を調整
        const main = document.querySelector('.v-main__wrap')
        const basearea = document.querySelector('.base-area')

        const area = document.querySelector('.inputDateArea')
        area.style.top = `${e.pageY - main.offsetTop - basearea.offsetTop}px`
        area.style.left = `${e.pageX - main.offsetLeft - basearea.offsetLeft}px`
        // 日付ピッカーの値を設定
        self.$refs.inputDate.lazyValue = typeof value === 'string' && dayjs(value, 'YYYY/MM/DD', true).isValid() ? value : null
        self.$refs.inputDate.onIconClick()
        // 日付ピッカーを開く
        self.$refs.inputDate.isShowCalendar = true
      }

      cell.appendChild(icon)
    },
    /* アイコンボタン項目 */
    setCustomCellIconButtonOnCondition: function (cell, x, y, value, rowData) {
      console.log('cond', cell, value, rowData)
      cell.textContent = ''
      if (value === true) {
        this.setCustomCellIconButton(cell, x, y, '', rowData)
      } else {
        const self = this
        var cellName = jSpreadSheet.helpers.getCellNameFromCoords(x, y)
        const ws = self.jspreadsheetObj.getWorksheetActive()
        const wss = self.jspreadsheetObj.getWorksheetInstance(ws)
        wss.setReadOnly(cellName, true)
      }
    },
    setCustomCellIconButton: function (cell, x, y, value, rowData) {
      console.log('setCustomCellDate')
      const column = this.getColumnCustom(x)
      // if (column.readOnly) { return }
      const self = this
      cell.style.position = 'relative'

      // アイコンボタン項目は読み取り専用にする
      var cellName = jSpreadSheet.helpers.getCellNameFromCoords(x, y)
      const ws = self.jspreadsheetObj.getWorksheetActive()
      const wss = self.jspreadsheetObj.getWorksheetInstance(ws)
      wss.setReadOnly(cellName, true)

      var icon = document.createElement('i')
      icon.className = 'material-icons'
      icon.innerHTML = ![undefined, null, ''].includes(column.mdiIcon) ? column.mdiIcon : 'circle'
      // if (self.isEnableDD) {
      //   icon.style.cursor = 'pointer'
      // } else {
      //   icon.style.cursor = 'default'
      // }
      icon.style.cursor = 'pointer'
      icon.style.fontSize = '18px'
      icon.style.position = 'absolute'
      icon.style.top = '50%'
      icon.style.transform = 'translateY(-50%) translateX(50%)'
      icon.onclick = function () {
        if (![undefined, null, ''].includes(column.buttonEvent)) {
          self.$emit(column.buttonEvent, rowData)
        } else {
          alert('クリックイベントがありません')
        }
      }

      cell.appendChild(icon)
    },
    onInputDate: function () {
      console.log('onInputDate')
      this.jspreadsheetObj.setValueFromCoords(this.selectedX, this.selectedY, this.inputDate)
      // 座標を設定
      this.jspreadsheetObj.updateSelectionFromCoords(this.selectedX, this.selectedY)
    },

    /**
     * 列制御
     */
    showColumn: function (colNum) {
      return this.jspreadsheetObj.showColumn(colNum)
    },
    hideColumn: function (colNum) {
      return this.jspreadsheetObj.hideColumn(colNum)
    },

    /**
     * ツールバー
     */
    rowAppendSingleAbove: function () {
      this.$emit('addRowAbove', 1)
    },
    rowAppendSingle: function () {
      this.$emit('addRow', 1)
    },
    rowDeleteSingle: function () {
      const selectedY = this.jspreadsheetObj?.selectedCell?.[1] ?? null
      this.$emit('deleteRow', 1, selectedY)
    },
    rowAppendMulti: function () {
      this.onBlurAppendRow()
      this.rowAppendDialog = false
      this.$emit('addRow', this.appendRow)
    },
    onBlurAppendRow: function () {
      // 行追加は最大100行まで
      if ([undefined, null, ''].includes(this.appendRow)) this.appendRow = 1
      if (this.appendRow > 100) this.appendRow = 100
    },
    resetAppendRow: function () {
      this.appendRow = null
    },
    overwriteAppendRow: function (num) {
      if ([null, ''].includes(this.appendRow)) {
        this.appendRow = num
      } else {
        this.appendRow = this.appendRow + '' + num
      }
    },

    /**
     * ツールバーイベント
     */
    onClickReturn: function () {
      this.$emit('return')
    },
    onClickRefresh: function () {
      this.$emit('refresh')
    },
    onClickDownload: function () {
      this.$emit('download')
    },
    onClickSave: function () {
      this.$emit('save')
    },
    /**
     * refsで呼ぶ便利なの
     */
    getActiveCell () {
      return this.selectedCell
    },
    setActiveCell (x, y) {
      this.jspreadsheetObj.updateSelectionFromCoords(x, y, x, y)
      return this.selectedCell
    },
    getColumnName (columnNumber) {
      return jSpreadSheet.helpers.getColumnName(columnNumber)
    },
    getCellNameFromCoords (x, y) {
      return jSpreadSheet.helpers.getCellNameFromCoords(x, y)
    },
    getCellFromCellName (cellName) {
      return this.jspreadsheetObj.getCell(cellName)
    },
    getStyleFromCellName (cellName) {
      return this.jspreadsheetObj.getStyle(cellName)
    },
    getRowData (y) {
      return this.jspreadsheetObj.getRowData(y)
    },
    setCellClass (x, y, className) {
      if (!this.jspreadsheetObj) { return }

      var cellName = jSpreadSheet.helpers.getCellNameFromCoords(x, y)
      var cell = this.jspreadsheetObj.getCell(cellName)
      if (cell !== undefined) {
        cell.classList.add(className)
      }
    },
    removeCellClass (x, y, className) {
      var cellName = jSpreadSheet.helpers.getCellNameFromCoords(x, y)
      var cell = this.jspreadsheetObj.getCell(cellName)
      if (cell !== undefined) {
        cell.classList.remove(className)
      }
    },
    setStyle (cellName, property, value, force = false) {
      return this.jspreadsheetObj.setStyle(cellName, property, value, force)
    },
    setCellReadonly (x, y, isReadonly) {
      var cellName = jSpreadSheet.helpers.getCellNameFromCoords(x, y)
      this.jspreadsheetObj.setReadOnly(cellName, isReadonly)
    },
    setCellComments (cellName, title, comment) {
      // this.jspreadsheetObj.setComments(cellName, comment)
      var cell = this.jspreadsheetObj.getCell(cellName)
      if (cell !== undefined) {
        if (comment === null) {
          cell.removeAttribute(title)
        } else {
          cell.setAttribute(title, comment)
        }
      }
    },
    // データ操作
    deleteTableRow (y, num) {
      this.jspreadsheetObj.deleteRow(y, num)
    },
    // 実行時に固定列を変更（APIメソッド版）
    setFreezeColumns (count) {
      if (!this.jspreadsheetObj) return
      const maxCols = (this.column || []).length
      const safe = Math.max(0, Math.min(Number(count) || 0, maxCols))

      // 1) ランタイム値を更新（再初期化でも維持させる）
      this.freezeColumnsRuntime = safe

      // 2) 現在のワークシートに即時反映（公式メソッド）
      const ws = this.jspreadsheetObj.getWorksheetActive()
      const wss = this.jspreadsheetObj.getWorksheetInstance(ws)
      wss.setFreezeColumns(safe) // ←← これが正解

      // （任意）選択復元
      if (this.selectedCell) {
        const [lx, ly, rx, ry] = this.selectedCell
        this.jspreadsheetObj.updateSelectionFromCoords(lx || 0, ly || 0, rx ?? lx ?? 0, ry ?? ly ?? 0)
      }
    },

    toggleFreezeFirstColumn () {
      if (!this.jspreadsheetObj) return
      const ws = this.jspreadsheetObj.getWorksheetActive()
      const wss = this.jspreadsheetObj.getWorksheetInstance(ws)
      const cur = (wss.getConfig().freezeColumns || 0)
      wss.setConfig({ freezeColumns: cur > 0 ? 0 : 1 })
    }
  }
}
</script>
<style scoped>
/* ツールバー */
.customToolBar {
  background-color:#f3f3f3;
  border: 1px solid #ccc;
  margin: 4px 1px !important;
}
.customToolBarFixed {
  position: sticky;
  z-index: 10;
  top: 60px;
}
::v-deep .jss_container {
  width: 100%;
}
::v-deep table.jss {
  white-space: pre;
}
::v-deep table.jss thead {
  word-break: break-word;
}
::v-deep .jss_container {
  /*
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 0px;
  padding-bottom: 4px;
  */
  padding: 0px;
  margin: auto;
}
::v-deep .jss_container.fullscreen {
  top: var(--fullscreen-top);
  height: var(--fullscreen-height) !important;
}
::v-deep .jss_container.fullscreen .jtabs-content {
  padding-bottom: 30px;
}
::v-deep .material-icons.data-access {
  color: #4169e1 !important;
}
::v-deep .jtoolbar .material-icons {
  font-size: 1.4rem;
}
::v-deep .jss_toolbar {
  z-index: 0 !important;
}
::v-deep .jtoolbar .jtoolbar-label {
  padding-left: 4px;
  padding-right: 4px;
}
::v-deep .toolbar_button {
  font-size: 0.8rem;
  padding: 0 6px 0 6px;
  font-style: normal;
}
::v-deep .jss_search_container {
  display: flex;
  justify-content: space-between;
  background-color: #fff;
  border: 1px solid #fff;
  border-bottom: 0;
}
::v-deep .jss_pagination_dropdown {
  margin-left: 4px;
  margin-right: 4px;
  padding-right: 4px;
  width: 40px;
  text-align: end;
  background-color: #FFF !important;
  border: 1px solid #777777 !important;
}
::v-deep .jss_pagination > div {
  display: flex;
  padding: 5px;
  font-size: 0.9em;
}
::v-deep .jss_pagination > div:last-child {
  padding-right: 10px;
  padding-top: 5px;
}
::v-deep .jss_pagination > div > div {
  text-align: center;
  width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 20px;
  border: 1px solid #ccc;
  box-sizing: border-box;
  margin-left: 2px;
  cursor: pointer;
}

::v-deep .jss_search {
  padding-right: 4px;
  width: 250px;
  background-color: #FFF !important;
  border: 1px solid #777777 !important;
}
::v-deep.jss_toolbar {
  z-index: 4;
}
::v-deep .jss_content {
  border-top: none !important;
  scrollbar-color: #83bde5 #eff6fd;
}

::v-deep .jss_content_overflow {
  overflow: auto;
  border-right: none;
  border-bottom: none;
}

::v-deep .jss > thead > tr:first-child > th {
  border-top: 1px solid #ccc !important;
}

::v-deep .jdropdown-default .jdropdown-cursor {
  background-color: #1f93ff;
  color: #FFF;
}
::v-deep table.jss > tbody > tr > td.readonly {
  color: black;
  background-color: #e8e8e8;
}
::v-deep .errorCell {
  background-color: #ffe6ef !important;
}
::v-deep .newCell {
  background-color: #ffff90;
}
::v-deep .changeCell {
  background-color: #ffff90 !important;
}

::v-deep .jss > tbody > tr > td:not(.jss_row) {
  text-align: left;
}
::v-deep .jss > tbody > tr > td.jss_right {
  text-align: right !important;
}
::v-deep .jss > tbody > tr > td.jss_center {
  text-align: center !important;
}
::v-deep .jss > tfoot > tr > td {
  bottom: -3px;
}
::v-deep .jss_sub_description {
  /* border: 1px solid #000 !important; */
  margin-top: 4px;
  width: 100% !important;
}

/* フルスクリーン用上部バー定義 */
::v-deep .jss_fullscreen_above {
  top: 58px;
  left: 0px;
  height: var(--fullscreen-top-above-height);
  width: 100%;
  background-color: #FFF !important;
  position: fixed;
  z-index: 6;
  padding: 6px 8px;
}
/* ヘッダーとの境界線 */
::v-deep .jss thead tr:nth-child(even) th {
  border-bottom: 1px solid #555;
}
</style>
<style>
@import url('https://fonts.googleapis.com/css?family=Material+Icons');
</style>
